// extracted by mini-css-extract-plugin
export default {"loader":"ShopifyGateway_loader__CjVOZ","loaderContainer":"ShopifyGateway_loaderContainer__xc0A0","rotation":"ShopifyGateway_rotation__pf27c","text":"ShopifyGateway_text__bFLNh"};